import { TwoColOneAd } from "./two-col-one-ad.js";
import { HalfImageSlider } from "./half-screen-slider.js";
import { FullscreenSimpleSlider } from "./fullscreen-simple-slider.js";
import { FullscreenLinearGallerySlider } from "./fullscreen-linear-gallery-slider.js";
import { ThreeCol } from "./three-col.js";
import { TwoCol } from "./two-col.js";
import { LShapeOneWidget } from "./l-shape-one-widget.js";
import { FullImageSlider } from "./full-screen-slider.js";
import { TwoColCarousel } from "./two-col-carousel.js";
import { TwoColHighlight } from "./two-col-highlight.js";
import { FourColGrid } from './four-col-grid.js';
import { OneColStoryList } from './one-col-story-list.js';

export default {
  HalfImageSlider,
  TwoColOneAd,
  FullscreenSimpleSlider,
  ThreeCol,
  FullscreenLinearGallerySlider,
  TwoCol,
  TwoColHighlight,
  TwoColCarousel,
  LShapeOneWidget,
  FullImageSlider,
  FourColGrid,
  OneColStoryList,
  defaultTemplate: ThreeCol
};
